import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationConfig {
  //created for Chapps Components library
  public static readonly PRIMARY_COLOR: string = "#4a4a4a";
  public static readonly SECONDARY_COLOR: string = "#f49b05";

  public readonly DEFAULT_PRIMARY_COLOR: string = "#4a4a4a";
  public readonly DEFAULT_PRIMARY_TEXT_COLOR: string = "#f49b05";
  public readonly DEFAULT_SECONDARY_COLOR: string = "#f49b05";
  public readonly DEFAULT_SECONDARY_TEXT_COLOR: string = "#ffffff";
  public readonly DEFAULT_FONT: string = "Roboto";
  public readonly DEFAULT_TEXT_COLOR: string = "#4a4a4a";
  public readonly DEFAULT_TITLE_TEXT_COLOR: string = "#f49b05";
  public readonly DATE_FORMAT: string = "dd/MM/yyyy";
  public readonly DATE_TIME_FORMAT: string = "dd/MM/yyyy, HH:mm";
  public readonly PDF_ICON_URL: string =
    "assets/images/file-extensions/pdf.png";
  public readonly DEFAULT_LOGO_URL: string = 'assets/images/chappslogo.png';
  public readonly DEFAULT_BACKGROUND_URL: string = "assets/background.jpg";
  public readonly MIN_PASSWORD_LENGTH: number = 6;
  public readonly BUILDING_MANAGER_BUILDING_THUMBNAIL: string =
    "assets/images/buildman-building-thumbnail.png";
  public readonly DORM_BUILDING_THUMBNAIL: string =
    "assets/images/buildman-building-thumbnail.png";
  public readonly DEFAULT_BUILDING_THUMBNAIL: string =
    "assets/images/buildman-building-thumbnail.png";
  public readonly MAX_RESOLUTION_TO_SHOW_BACK_BUTTON: number = 1199;
  readonly BUILDING_PLACEHOLDER_URL: string =
    "assets/images/building-placeholder.png";
  public readonly BACK_BUTTON_REGEXP_PAGES: string[] = ["^\\/.*\\/.*\\/.+"];
  public readonly STRUCTURE_ELEMENT_TYPES: string[] = ['BasicElementGroup', 'BasicElement', 'SpecificElementGroup', 'SpecificElement', 'ConformityElementGroup', 'ConformityElement'];
  public readonly SUPPORTED_IMAGE_FILE_EXTENSIONS: string[] = ['jpg', 'jpeg', 'png'];

}
